var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stay" }, [
    _c(
      "div",
      {
        staticClass: "stay__wrapper",
        class: [{ active: _vm.mapView }, { index: _vm.filtersActive }],
      },
      [
        _c("product-filters", {
          attrs: {
            empty: _vm.filtersEmpty,
            total: _vm.total,
            "show-map": _vm.pins.length > 0,
            product: _vm.product,
            buttons: _vm.buttons,
            dates: _vm.dates,
          },
          on: {
            togglemap: function ($event) {
              _vm.mapView = !_vm.mapView
            },
            toggleopen: _vm.toggleFilters,
            clearfilters: _vm.clearFilters,
          },
          model: {
            value: _vm.model,
            callback: function ($$v) {
              _vm.model = $$v
            },
            expression: "model",
          },
        }),
        _vm._v(" "),
        _vm.pins.length > 0
          ? _c(
              "div",
              { staticClass: "stay__location" },
              [_c("product-map", { attrs: { pins: _vm.pins } })],
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "stay__body" }, [
      _c(
        "div",
        { staticClass: "stay__container container" },
        [
          _c(
            "h1",
            { staticClass: "stay__title title title_big" },
            [_vm._t("title")],
            2
          ),
          _vm._v(" "),
          _vm._t("intro"),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "stay__list" },
            [
              _vm._l(_vm.curPage, function (item) {
                return !_vm.loading
                  ? _c("product-item", { key: item.Id, attrs: { model: item } })
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm._l(_vm.params.perPage, function (i) {
                return _vm.loading
                  ? _c("skeleton", { key: "skeleton_" + i })
                  : _vm._e()
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.results.length == 0
            ? _c("p", { staticClass: "text-center mt-5" }, [
                _vm._v("Nothing matched your search"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.pages > 1
            ? _c("ul", { staticClass: "pagination" }, [
                _vm.params.page > 0
                  ? _c("li", { staticClass: "pointer" }, [
                      _c(
                        "a",
                        {
                          staticClass: "pagination__prev",
                          on: {
                            click: function ($event) {
                              return _vm.setPage(_vm.params.page - 1)
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "36",
                                height: "13",
                                viewBox: "0 0 36 13",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    transform: "matrix(-1 0 0 -1 35.5 12.5)",
                                    fill: "#009dbb",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M35 6.5H0A.5.5 0 0 1-.5 6a.5.5 0 0 1 .5-.5h35a.5.5 0 1 1 0 1z",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M35 6.5a.5.5 0 0 1-.354-.146l-6-6a.5.5 0 0 1 0-.707.5.5 0 0 1 .707 0l6 6A.5.5 0 0 1 35 6.5z",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M29 12.5a.5.5 0 0 1-.354-.853l6-6a.5.5 0 0 1 .707.707l-6 6A.5.5 0 0 1 29 12.5z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.params.page > 0
                  ? _c(
                      "li",
                      {
                        staticClass: "pointer",
                        on: {
                          click: function ($event) {
                            return _vm.setPage(_vm.params.page - 1)
                          },
                        },
                      },
                      [_c("a", [_vm._v(_vm._s(_vm.displayPage - 1))])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("li", { staticClass: "pointer" }, [
                  _c("a", { staticClass: "active" }, [
                    _vm._v(_vm._s(_vm.displayPage)),
                  ]),
                ]),
                _vm._v(" "),
                _vm.params.page < _vm.pages - 1
                  ? _c(
                      "li",
                      {
                        staticClass: "pointer",
                        on: {
                          click: function ($event) {
                            return _vm.setPage(_vm.params.page + 1)
                          },
                        },
                      },
                      [_c("a", [_vm._v(_vm._s(_vm.displayPage + 1))])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.params.page < _vm.pages - 1
                  ? _c("li", { staticClass: "pointer" }, [
                      _c(
                        "a",
                        {
                          staticClass: "pagination__next",
                          on: {
                            click: function ($event) {
                              return _vm.setPage(_vm.params.page + 1)
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "36",
                                height: "13",
                                fill: "#009dbb",
                                viewBox: "0 0 36 13",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M35.5 7H.5a.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5h35a.5.5 0 1 1 0 1z",
                                },
                              }),
                              _c("path", {
                                attrs: {
                                  d: "M35.5 7a.5.5 0 0 1-.354-.146l-6-6a.5.5 0 0 1 0-.707.5.5 0 0 1 .707 0l6 6A.5.5 0 0 1 35.5 7z",
                                },
                              }),
                              _c("path", {
                                attrs: {
                                  d: "M29.5 13a.5.5 0 0 1-.354-.853l6-6a.5.5 0 0 1 .707.707l-6 6A.5.5 0 0 1 29.5 13z",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }